import {
  EstadosAgendamientoEnumChoice,
  EstadosLlamadaEnumChoice,
  ROUTER_PATHS,
  toHour,
  toHours,
  TrazabilidadAccionChoiceEnum,
  useLoaders,
} from "@/shared";
import {
  AproveRecoordinacionData,
  CreateAgendamientoParamsForm,
  getContrato,
  useUpdateAgendamiento,
} from "@/shared/actions/erp";
import {
  CustomButtunsRejectConfirm,
  LoaderComponent,
  SingleFormBoxScene,
} from "@/shared/components/ui";
import {
  Agendamiento,
  AlertSeverityEnum,
  CacheKeyCalendarioENUM,
  Contrato,
  EstadoBitacoraEnum,
  IDataPreventa,
  IDataProspecto,
} from "@/shared/interfaces";
import {
  calcTrazavilidadVendedor,
  convertirFormatoHoraArray,
  convertirHoraADecimalArray,
  handleErrorForm,
  hasPermission,
  preagendamientoFormSchema,
} from "@/shared/utils";
import { useUiStore } from "@/store/ui";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useFlotasStore } from "@/store/erp";
import { useDiccionarioMotivo } from "@/store/erp/diccionario_motivo/diccionario_motivo.store";
import { PermissionsEnum } from "@/auth/interfaces";
import RejectRecoordinadoModal from "@/erp/operaciones/agendamiento/shared/components/forms/RejectRecoordinadoModal";
import AgendamientoSingleOrdenServicioTraslado from "./AgendamientoSingleOrdenServicioTraslado";
import useSelectDateTimerPreScheduling, { DepartamentoSelectScheduling } from "@/erp/sale/component/calendario-preagendamiento-venta/useSelectDateTimerPreScheduling.store";
import { toast } from "react-toastify";
import { useAuthStore } from "@/store/auth";
import {
  nombreUsuario,
  trazaOtrosConceptos,
  trazaPuntosRed,
} from "../otros-conceptos-traslado/conceptos-traslado.utils";

export interface SaveAgendamientoOrdenTrasladoProps {
  title: string;
  agendamiento?: Agendamiento;
  enableGestionVenta?: boolean
}

// PERF: la base era CreateAgendamientoParamsForm & Partial<IDataPreventa>(139 props) & Partial<IDataProspecto>,
// intersección enorme que hacía explotar Path<T> en cada useForm<SaveFormDataRecoordinacion> (tsc de 16-33 min).
// Se reemplaza la base por Record<string,any> (permisivo); se mantienen tipados los campos explícitos de abajo
// que el form realmente usa. Mismo comportamiento en runtime.
export type SaveFormDataRecoordinacion = Record<string, any> & {
    planLabel?: string;
    velocidad_internet?: string;
    valor_instalacion?: string;

    // prospecto
    puntaje_score: string;
    puntaje_empresa: string;
    puntaje_score_sobreendeudamiento: string;

    // preventa
    provincia: string;
    ciudad: string;
    zona: string;
    sector: string;
    observacion_1: string;
    observacion_2: string;

    // preagenda/agenda
    observacion_llamada: string;
    es_referido?: string;
    flotaRaw?: string;

    isRejecting?: boolean;
    observacion_rechazo?: string;
    id_preventa?: string;
    cantidad_reversos?: number;
  };

//export type SaveFormDataRecoordinacion = any;

const SaveAgendamientoOrdenTraslado: React.FC<SaveAgendamientoOrdenTrasladoProps> = ({
  title,
  agendamiento,
  enableGestionVenta = hasPermission(
    PermissionsEnum.pyl_administrator_permission
  ),
}) => {
  const navigate = useNavigate();
  const returnUrlAgendamientosPyLPage =
    ROUTER_PATHS.operaciones.trasladosPyLNav;


  ///* local state --------------------
  const [shrink] = useState(true);
  // La acción es "Recoordinar" (no "Confirmar") cuando el traslado ya está
  // agendado/rechazado/recoordinado (tabs Agendado, Traslados Rechazados y
  // Traslados Recoordinados). El submit ya lo pasa a RECORDINADO en esos casos.
  const esAgendado = [
    EstadosAgendamientoEnumChoice.FINALIZADO,
    EstadosAgendamientoEnumChoice.RECORDINADO,
    EstadosAgendamientoEnumChoice.PENDIENTE_RECORDINACION,
  ].includes(agendamiento?.estado_agendamiento as any);
  const setAlert = useUiStore((s) => s.setAlert);
  const [openRechazoModal, setOpenRechazoModal] = useState(false);
  const [dataContrato, setDataContrato] = useState<Contrato | null>(null);

  ///* global state --------------------

  const getFloat = useSelectDateTimerPreScheduling(s => s.getFloat);
  const setIsSave = useSelectDateTimerPreScheduling(s => s.setIsSave);
  const handleValidDateHour = useSelectDateTimerPreScheduling(s => s.handleValidDateHour);
  const blocked = useSelectDateTimerPreScheduling(s => s.blocked);
  const selectFloat = useSelectDateTimerPreScheduling(s => s.selectFloat);
  const isLoadingFloat = useSelectDateTimerPreScheduling(s => s.isLoadingFloat);
  const selectDate = useSelectDateTimerPreScheduling(s => s.selectDate);
  const slot = useSelectDateTimerPreScheduling(s => s.slot);
  const setPreventa = useSelectDateTimerPreScheduling(s => s.setPreventa);
  const unblockPlanification = useSelectDateTimerPreScheduling(s => s.unblockPlanification);
  const setConfigParams = useSelectDateTimerPreScheduling(s => s.setConfigParams);
  const user = useAuthStore(s=>s.user);

  const emitFinalizarVenta = useDiccionarioMotivo((s) => s.emitFinalizarVenta);

  const {
    getFlotasPreagendamiento,
    isLoadingFlotasPreagendamiento
  } =
    useFlotasStore();

  ///* form --------------------
  const form = useForm<SaveFormDataRecoordinacion>({
    resolver: yupResolver(preagendamientoFormSchema) as any,
    defaultValues: {
      estado: true,
    },
  });

  const {
    handleSubmit,
    reset,
    formState: { isValid },
  } = form;

  ///* mutations --------------------
  const updatePreagendamientoMutation =
    useUpdateAgendamiento<AproveRecoordinacionData>({});


  // cargar planificador
  useEffect(() => {

    setConfigParams({
          time: 60 * 1000,
          tiempo :CacheKeyCalendarioENUM.TIEMPO_LIMITE_PYL,
          motivo: CacheKeyCalendarioENUM.MENSAJE_BLOQUEO_PYL,
          departamento: DepartamentoSelectScheduling.PYL
         } )

    if (!agendamiento) return;

    (async () => {
      await Promise.all([
        getFloat({
          estado: true,
          // Traslado: filtrar flotas por la zona de la NUEVA ubicación (contrato),
          // con fallback a la de la preventa.
          zonas: agendamiento?.contrato_data?.zona || agendamiento?.preventa_data?.zona,
          page_size: 100,
        }),
        setPreventa(agendamiento?.preventa_data?.id_preventa!)
      ]);
    })();


    return () => {
      unblockPlanification()
    }
  }, [agendamiento?.id_agendamiento])

  // cuando no existe flota en el form, se asigna la flota seleccionada
  useEffect(() => {
    if(!form.getValues("flota")){
      form.setValue("flota", selectFloat)
    }
  }, [selectFloat])

  /**
* Determina el siguiente estado del agendamiento basado en el resultado de la llamada.
*/
  const determinarNuevoEstadoAgendamiento = (data: SaveFormDataRecoordinacion, agendamiento: Agendamiento) => {
    const { estado_llamada, isRejecting } = data;
    const { estado_agendamiento } = agendamiento;

    // 1. Prioridad: No contesta
    if (estado_llamada === EstadosLlamadaEnumChoice.NO_CONTESTA) {
      return EstadosAgendamientoEnumChoice.EN_PAUSA;
    }

    // 2. Prioridad: Rechazo manual
    if (isRejecting) {
      return EstadosAgendamientoEnumChoice.PRERECHAZADO;
    }

    // 3. Lógica según el estado actual del agendamiento
    if (estado_agendamiento === EstadosAgendamientoEnumChoice.EN_ESPERA || estado_agendamiento === EstadosAgendamientoEnumChoice.EN_PAUSA) {
      return EstadosAgendamientoEnumChoice.FINALIZADO;
    }

    // 4. Caso por defecto
    return EstadosAgendamientoEnumChoice.RECORDINADO;
  };

  ///* handlers --------------------
  const onSave = async (data: SaveFormDataRecoordinacion) => {
    if (!isValid) return;

    setIsSave(true)


    if (selectDate == null || slot == null || selectFloat == null)
      return toast.error(
        "Selecionar un técnico con fecha y hora de instalación.",
      );

    if (
      data.estado_llamada === EstadosLlamadaEnumChoice.REALIZADA &&
      !data.isRejecting
    ) {
      const esValid = await handleValidDateHour(user?.id)
      if (!esValid) return;

    }

    ///* upd
    if (agendamiento?.id_agendamiento) {
      const resp = await updatePreagendamientoMutation.mutateAsync({
        id: agendamiento.id_agendamiento!,
        data: {
          celular: data.celular!,
          celular_2: data.celular_2!,
          email: data.email!,
          direccion: data.direccion!,
          coordenadas: data.coordenadas!,
          estado_llamada: data.estado_llamada!,
          fecha_hora_llamada: data.fecha_hora_llamada!,
          nap: data.nap,
          distancia: data.distancia,

          observaciones: {
            // Preservar las observaciones propias del traslado (observacion_traslado,
            // ubicacion_anterior, recaudacion, etc.) y añadir la de recoordinación.
            ...agendamiento?.observaciones,
            ...agendamiento?.preventa_data?.observaciones,
            observacion_llamada: data.observacion_llamada!,
            observacion_rechazo: data.observacion_rechazo || "",
            observacion_recoordinar: (data as any).observacion_recoordinar || "",
            // Otros conceptos + puntos de red del traslado (catálogo de traslados),
            // con trazabilidad de quién los cambió desde Operaciones.
            otros_conceptos: (data as any).otros_conceptos || [],
            otros_conceptos_historial: trazaOtrosConceptos(
              (agendamiento?.observaciones as any)?.otros_conceptos,
              (data as any).otros_conceptos,
              (agendamiento?.observaciones as any)?.otros_conceptos_historial,
              nombreUsuario(user),
              "operaciones"
            ),
            puntos_red: (data as any).puntos_red || [],
            puntos_red_historial: trazaPuntosRed(
              (agendamiento?.observaciones as any)?.puntos_red,
              (data as any).puntos_red,
              (agendamiento?.observaciones as any)?.puntos_red_historial,
              nombreUsuario(user),
              "operaciones"
            ),
          },
          pais: data.pais!,
          ciudad: data.ciudad!,
          provincia: data.provincia!,
          zona: data.zona!,
          sector: data.sector!,
          persona_referencia_celular: data.persona_referencia_celular!,
          persona_referencia_nombre: data.persona_referencia_nombre!,
          persona_referencia_parentesco: data.persona_referencia_parentesco!,

          estado_agendamiento: determinarNuevoEstadoAgendamiento(data, agendamiento),
          motivo_rechazo: data.motivo_rechazo || null,
          observacion_rechazo: data.observacion_rechazo || null,
          id_preventa: data?.preventa_data?.id_preventa,

          ///* Cambio de flota y hora de instalacion.
          // En traslado el agendamiento es NUEVO: arriba (linea ~215) ya se valida
          // que selectFloat/selectDate/slot NO sean null, asi que usamos la
          // seleccion del calendario DIRECTO en vez de depender de `blocked` (que
          // a veces no quedaba en true y mandaba data.flota vacio -> "Campos
          // obligatorios: Flota"). Fallback a data.* por seguridad.
          flota: selectFloat || data.flota,
          fecha_instalacion: selectDate
            ? selectDate.format("YYYY-MM-DD")
            : data.fecha_instalacion,
          hora_instalacion: slot ? toHour(slot.hora) : data.hora_instalacion!,
          horas: convertirFormatoHoraArray(
            slot
              ? toHours(slot.hora)
              : convertirHoraADecimalArray(data.hora_instalacion)
          ),
          fecha_instalacion_original:
            agendamiento.preagendamiento_data?.fecha_instalacion!,
          hora_instalacion_original:
            agendamiento.preagendamiento_data?.hora_instalacion!,
        } as any,
      });

      if (resp.code == 200) {
        emitFinalizarVenta({
          numero_referencia_venta:
            agendamiento.preagendamiento_data?.id_preagendamiento!,
          estado_venta: EstadoBitacoraEnum.FINALIZADO,
        });


        navigate(returnUrlAgendamientosPyLPage);
      }

      return;
    }
  };

  ///* effects --------------------
  useEffect(() => {
    if (!agendamiento?.id_agendamiento) return;

    const {
      preventa_data,
      prospecto_data,
      pais_data,
      provincia_data,
      ciudad_data,
      zona_data,
      sector_data,
      plan_data,
      flota_data,
      trazo_venta_data,
      contrato_data,
      ...rest
    } = agendamiento;

    reset({
      ...prospecto_data,
      //...preventa_data,
      ...contrato_data,
      ...rest,
      nacionalidad: pais_data?.nacionalidad!,
      observacion_1: preventa_data?.observaciones?.observacion_1 || "",
      observacion_2: preventa_data?.observaciones?.observacion_2 || "",

      vendedor_name: calcTrazavilidadVendedor(
        trazo_venta_data || [],
        TrazabilidadAccionChoiceEnum.CREACION,
        "user"
      ),
      es_referido: !!preventa_data?.tipo_referido ? "SI" : "NO",
      planLabel: plan_data?.nombre!,
      velocidad_internet: preventa_data?.velocidad
        ? `${preventa_data?.velocidad} ${plan_data?.unidad}`
        : "",

      isRejecting: false,

      // recoordinacion
      fecha_instalacion: agendamiento?.fecha_instalacion || "",
      hora_instalacion: agendamiento?.hora_instalacion || "",

      nap: agendamiento?.nap || "",
      distancia: agendamiento?.distancia || "",
      flota: agendamiento?.flota || "",
      flotaRaw: agendamiento?.flota_data || {},

      observacion_llamada:
        agendamiento.observaciones?.observacion_llamada || "",
      observacion_rechazo:
        agendamiento.observaciones?.observacion_rechazo || "",
      observacion_recoordinar:
        (agendamiento.observaciones as any)?.observacion_recoordinar || "",
      coordenadas: agendamiento.coordenadas,
      // Otros conceptos / puntos de red del traslado (se editan en el formulario).
      otros_conceptos: (agendamiento.observaciones as any)?.otros_conceptos || [],
      puntos_red: (agendamiento.observaciones as any)?.puntos_red || [],
    } as unknown as SaveFormDataRecoordinacion);
  }, [agendamiento, reset]);

  useEffect(() => {
    ///* Verificar si existe datos en cache, para la obtencion del tiempo del planificador
    getFlotasPreagendamiento({
      zonas: agendamiento?.contrato_data.zona,
      page_size: 100,
    });

    if (!isLoadingFlotasPreagendamiento) {

    }

    return () => {

    };
  }, []);

  useEffect(() => {

    if (!agendamiento) return

    async function fetch() {
      const resp = await getContrato(agendamiento?.contrato_data.id_contrato!)
      setDataContrato(resp?.data!)
    }
    fetch()
  }, [agendamiento?.id_agendamiento])

  //useLoaders(!!!dataContrato)

  useLoaders(
    isLoadingFloat
  )

  if (!!!dataContrato) {
    return <LoaderComponent />
  }

  return (
    <SingleFormBoxScene
      titlePage={esAgendado ? "Recoordinar Traslado" : title}
      showCustomBtns={true}
      showActionBtns={false}
      num_referencia={`${agendamiento?.prospecto_data?.razon_social} — L${agendamiento?.prospecto_data?.linea}`}
      customBtns={
        <CustomButtunsRejectConfirm
          confirmTextBtn={esAgendado ? "Recoordinar" : "Confirmar"}
          onCancel={() => navigate(returnUrlAgendamientosPyLPage)}
          onConfirm={() => {
            form.handleSubmit(onSave, (err) => {
              if (err?.estado_llamada || err?.observacion_llamada)
                return setAlert(
                  true,
                  "El estado de llamada y su observación son requeridos",
                  AlertSeverityEnum.error
                );
              handleErrorForm(err);
            })();
          }}
          rejectTextBtn="Enviar a Gestión Ventas"
          showRejectBtn={enableGestionVenta}
          onReject={() => {
            setOpenRechazoModal(true);
            form.reset({
              ...form.getValues(),
              isRejecting: true,
            });
          }}
          sxContainer={{
            pt: 1,
          }}
        />
      }
    >
      {
        dataContrato && (
          <>
            <AgendamientoSingleOrdenServicioTraslado
              form={form as any}
              shrink={shrink}
              agendamiento={agendamiento!}
              contrato={dataContrato}
            />
          </>
        )
      }

      {/* =================== DIALOG =================== */}
      <RejectRecoordinadoModal
        open={openRechazoModal}
        onClose={() => {
          setOpenRechazoModal(false);
        }}
        agendamiento={agendamiento!}
        form={form}
        onConfirm={() => {
          handleSubmit(onSave, (err) => {
            handleErrorForm(err);
          })();
        }}
      />
    </SingleFormBoxScene>
  );
};

export default SaveAgendamientoOrdenTraslado;
